import { termosStep } from '../../shared/termosSections';
import { inscricaoReferenciaSection, porCategoriaOuInscricaoReferencia } from '../../shared/juntadaSections';

const pedidoJuntadaRecursoConfig = {
  id: 'pedido_JuntadaRecurso',
  nome: 'Pedido de Juntada de Recurso',
  categoria: 'pedidos',
  descricao: 'Solicitação de juntada de recurso',
  icon: 'FaTrashAlt',

  documentConfig: {
    documentosAdicionais: true,
    required: [
      { 
        id: 'manifestacao_recurso', tipoDocumentoProcesso: 489, 
        name: 'Manifestação do Recurso', 
        description: 'Documento contendo a manifestação do recurso.', 
        required: true 
      },
    ],
  },

  paymentConfig: {
    amount: 0
  },

  protocoloConfig: {
    modeloRequerimento: porCategoriaOuInscricaoReferencia({ 'ADVOGADO(A)': '282', 'ESTAGIÁRIO(A)': '289' }),
    tiposAssunto: '837',
    tipoPedido: porCategoriaOuInscricaoReferencia({ 'ADVOGADO(A)': '489', 'ESTAGIÁRIO(A)': '490' })
  },

  // Confirmado ao vivo contra GET /modelo-requerimento/{282,289}/campos: só 2 campos.
  dadosRequerimentoConfig: {
    campos: [
      { field: 'nomeCompleto', campoNome: 'Nome' },
      { field: 'cpf', campoNome: 'CPFCNPJ' }
    ]
  },

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Identificação do Requerente',
          fields: [
            { 
              type: 'text', 
              name: 'nomeCompleto', 
              label: 'Nome completo', 
              required: true, 
              placeholder: 'Digite seu nome completo' 
            },
            { 
              type: 'cpf', 
              name: 'cpf', 
              label: 'CPF', 
              required: true 
            }
          ]
        },
        inscricaoReferenciaSection
      ]
    },
    termosStep()
  ]
};

export default pedidoJuntadaRecursoConfig;